import { render } from "./participateDBCAiMining.vue?vue&type=template&id=33c11934&scoped=true"
import script from "./participateDBCAiMining.vue?vue&type=script&lang=js"
export * from "./participateDBCAiMining.vue?vue&type=script&lang=js"

import "./participateDBCAiMining.vue?vue&type=style&index=0&id=33c11934&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c11934"]])

export default __exports__